<template>
	<div class="Support Support-list">
		<div class="buttons">
			<vs-button
				v-if="$store.state.auth.role !== 'admin'"
				color="primary"
				@click="popupActive = true"
				type="filled"
			>{{ $t('openDiscuss') }}</vs-button>
		</div>
		<vx-card class="my-8">
			<vs-tabs>
				<vs-tab :label="$t('opened')">
					<div class="tab-text">
						<vs-table max-items="10" pagination v-if="supports.open.length > 0"
								  :data="supports.open">
							<template slot="thead">
								<vs-th>
									{{ $t('number') }}
								</vs-th>
								<vs-th>
									{{ $t('discussTheme') }}
								</vs-th>
								<vs-th class="center">
									{{ $t('status') }}
								</vs-th>
								<vs-th class="center">
									{{ $t('close') }}
								</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>
										<div class="mb-5" @click="$router.push('/support/'+tr.id )">
											<div><b>{{ tr.id }}</b></div>
											<div><span>{{ tr.created | moment("DD.MM.YYYY HH:mm") }}</span></div>
										</div>
										<span>{{ betweenDate(tr.created) }}</span>
									</vs-td>
									<vs-td class="message">
										<div @click="$router.push('/support/'+tr.id )">
											<strong>{{ tr.title }}</strong>
											<p class="mb-5">
												{{ getShortMessage(getLastMessage(tr).message) }}
											</p>
											<div>
												<span>{{ $t('lastAnswer') }}:
													{{ getLastMessage(tr).created | moment("DD.MM.YYYY HH:mm") }}
												</span>
											</div>
										</div>
									</vs-td>
									<vs-td class="center">
										<span
											@click="$router.push('/support/'+tr.id )"
											class="status status-accept"
											v-if="tr.status === 5"
										>{{ $t('answerReceived') }}</span>
										<span
											@click="$router.push('/support/'+tr.id )"
											class="status status-warn"
											v-else
										>{{ $t('waitingToAnswer') }}</span>
									</vs-td>
									<vs-td class="center">
										<span class="cursor-pointer" @click="openAlert('warning' , tr.id)">
											<svg width="24" height="24" x="0" y="0" class="stencil--easier-to-select"
												 style="opacity: 1;">
												<defs></defs>
												<rect x="0" y="0" width="24" height="24" fill="transparent"
													  class="stencil__selection-helper"></rect>
												<path
													d="M11.999999999999998 0C5.363999999999999 0 0 5.363999999999999 0 11.999999999999998 0 18.636000000000003 5.363999999999999 24 11.999999999999998 24 18.636000000000003 24 24 18.636000000000003 24 11.999999999999998 24 5.363999999999999 18.636000000000003 0 11.999999999999998 0 11.999999999999998 0 11.999999999999998 0 11.999999999999998 0M18 16.308C18 16.308 16.308 18 16.308 18 16.308 18 11.999999999999998 13.691999999999998 11.999999999999998 13.691999999999998 11.999999999999998 13.691999999999998 7.692 18 7.692 18 7.692 18 6 16.308 6 16.308 6 16.308 10.308 11.999999999999998 10.308 11.999999999999998 10.308 11.999999999999998 6 7.692 6 7.692 6 7.692 7.692 6 7.692 6 7.692 6 11.999999999999998 10.308 11.999999999999998 10.308 11.999999999999998 10.308 16.308 6 16.308 6 16.308 6 18 7.692 18 7.692 18 7.692 13.691999999999998 11.999999999999998 13.691999999999998 11.999999999999998 13.691999999999998 11.999999999999998 18 16.308 18 16.308 18 16.308 18 16.308 18 16.308"
													stroke-width="0" stroke="none" stroke-dasharray="none"
													fill="rgb(98, 98, 98)" fill-rule="evenOdd"></path>
											</svg>
										</span>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
				<vs-tab :label="$t('closed')">
					<div class="tab-text">
						<vs-table max-items="10" pagination v-if="supports.close.length > 0"
								  :data="supports.close">
							<template slot="thead">
								<vs-th>
									{{ $t('number') }}
								</vs-th>
								<vs-th>
									{{ $t('discussTheme') }}
								</vs-th>
								<vs-th class="center">
									{{ $t('status') }}
								</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr"
									   v-for="(tr, indextr) in data">
									<vs-td @click="$router.push('/support/'+tr.id )">
										<div @click="$router.push('/support/'+tr.id )">
											<div><b>{{ tr.id }}</b></div>
											<div><span>{{ tr.created | moment("DD.MM.YYYY HH:mm") }}</span></div>
										</div>
									</vs-td>
									<vs-td class="message">
										<div @click="$router.push('/support/'+tr.id )">
											<strong>{{ tr.title }}</strong>
											<p>
												{{ getShortMessage(getLastMessage(tr).message) }}
											</p>
										</div>
									</vs-td>
									<vs-td class="center">
										<span class="status status-danger">{{ $t('isClosed') }}</span>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
		<vs-popup
			classContent="create-appeal"
			:title="$t('openNewDiscuss')"
			class="primary-popup support-create-appeal"
			:active.sync="popupActive"
		>
			<div class="form-input mb-3">
				<vs-input
					:key="'supportListThemeInput' + popupInputCounter"
					:label="`${$t('discussTheme')}*`"
					name="theme"
					v-validate="'required|min:3'"
				  	v-model="theme"
				/>
				<span v-if="errors.first('theme')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="form-input">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary custom-primary-focus">
					<label :class="{ 'focused-label': isPopupInputFocused }" class="vs-input--label">
						{{ $t('discussText') }}*
					</label>
					<div class="vs-con-input">
					</div>
					<vs-textarea
						v-model="text"
						:key="'supportListTextInput' + popupInputCounter"
						name="text"
						v-validate="'required|min:3'"
						class="vs-input-primary"
						@focusin="isPopupInputFocused = true"
						@focusout="isPopupInputFocused = false"
					/>
				</div>
				<span v-if="errors.first('text')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="form-input">
				<vs-upload
					:key="`uploadImageKey${popupActive}`"
					:show-upload-button="false"
				   	@change="successUpload"
					:text="$t('loadFile')"
					accept=".jpg,.jpeg,.png,.xls,.xlsx,.docx,.doc,.odt,.rtf,.pdf,.txt,.csv,.zip,.pages,.sav,.MP4,.MOV,.MPG,.AVI,.M4V,.3GP,.3GGP,.MX20,.MX18,.MX12,.r,.ppt,.pptx"
				/>
			</div>
			<vs-button color="primary" @click="saveNewSupport">{{ $t('save') }}</vs-button>
			<vs-custom-button @click="popupActive = false" color="#9a9a9a" type="flat">{{ $t('cancel') }}</vs-custom-button>
		</vs-popup>
		<vs-popup
			class="holamundo terminate-popup"
			:title="$t('confirmAction')"
			:active.sync="terminatingPopupActive"
		>
			<p>
				{{ $t('doYouWantToCloseDiscuss') }}  <b>№ {{ this.deletedId }}</b>
			</p>
			<div class="vs-popup--button">
				<vs-button
					@click="terminateSupport"
					color="warning"
				>{{ $t('closeDiscuss') }}</vs-button>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import supportMixin from '@/mixins/support';
import notifier from '../../mixins/notifier';

export default {
	mixins: [supportMixin, notifier],
	name: "List",
	data(){
		return{
			supports: {
				open: [],
				close: [],
			},
			isPopupInputFocused: false,
			popupActive: false,
			popupInputCounter: 0,
			files: [],
			theme: "",
			text: ""
		}
	},
	watch: {
		popupActive(value) {
			if(value) {
				this.popupInputCounter++;
				this.theme = "";
				this.text = "";
			}
		}
	},
	methods: {
		getShortMessage(message) {
			return message.length > 70
				? message.substr(0, 70) + '...'
				: message;
		},
		getLastMessage(tr) {
			let last = {};

			if(tr.last_message) {
				last = tr.last_message;
			} else {
				last = tr.messages[tr.messages.length - 1];
			}

			return last;
		},
		successUpload(err, file) {
			this.files.push(file[file.length - 1]);
		},
		async uploadFile(file) {
			try {
				const res = await this.$http.post('/upload/one',this.$formData({file: file}));
				return res.data.data.path;

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async saveNewSupport() {
			try {
				this.$validator.validateAll().then(async result => {
					let files = await Promise.all(this.files.map(async item => await this.uploadFile(item)));

					if (result) {
						let formData = {
							title: this.theme,
							message: this.text,
							files: files,
						}
						let res = (await this.$http.post('/support/create/', formData)).data.data;
						this.supports.open.unshift(res);

						this.popupActive = false;
						this.text = '';
						this.files = [];
						this.notifySuccess(this.$t('dataIsSaved'));
					}
				});
			} catch (e) {
				this.notifyError(e.message)
			}
		},
		async getData(){
			this.supports.open = (await this.$http.get('/support?tab=active')).data.data;
			this.supports.close = (await this.$http.get('/support?tab=closed')).data.data;
		},
		terminateSupport() {
			this.closeSupport().then(() => {
				const index = this.supports.open.findIndex(item => item.id === this.deletedId);

				if(index === -1) return;

				const item = this.supports.open[index];
				this.supports.open.splice(index, 1);
				this.supports.close.unshift(item);
			});
 		}
	},
	async created() {
		await this.getData();
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.create-appeal {
	.con-input-upload, .img-upload {
		margin: 15px 0;
		margin-top: 0;
	}

	.img-upload {
		margin-right: 15px;
	}

	.con-img-upload {
		padding: 0;
		margin-top: 0;
	}

	.vs-textarea {
		height: 120px;
	}

	.vs-con-input-label {
		width: 100%;
	}
}

.Support {
	&-list {
		.buttons {
			justify-content: flex-end;
			display: flex;
		}


	}

	.vs-table {
		th {
			&.center .vs-table-text {
				justify-content: center;
			}
		}

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

	.vs-tabs--content {
		padding-left: 0;
		padding-right: 0;
	}
}


.status {
	&-accept {
		color: $success;
	}

	&-danger {
		color: $danger;
	}

	&-warn {
		color: $warning;
	}
}

.vs-table--td {
	&.message {
		width: 700px;
	}

	&.center {
		text-align: center;
	}
}

.support-create-appeal {
	.vs-con-textarea {
		margin-bottom : 0;
	}

	.con-upload {
		margin-top: 16px;
	}
}

.terminate-popup {
	.vs-popup{
		max-width: 600px !important;
		width: 100% !important;
		padding: 0;

		&--content{
			width: 100%;
			height: 100%;
		}

		&--title {
			h3 {
				color: $warning;
			}
		}

		&--close {
			color: $warning;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}
}
</style>
